"use strict";

var root = typeof window === 'undefined' ? global : window;
var bunsen = root.bunsen = root.bunsen || {};
var accounting = require('bunsen/libraries/accounting');
var currency = require('bunsen/libraries/currency');

var price = {};

bunsen.formatPrice = price.formatPrice = function (amount, currencyEnum, passedPrecision) {
    var myCurrency = currency(currencyEnum);
    var precision = passedPrecision || 0;
    var currencySymbol = myCurrency ? myCurrency.symbol : null;
    var formatOptions = {
            precision: precision,
            symbol: currencySymbol,
            format: {
                pos : "%s%v",
                neg : "- %s%v",
                zero: "%s0"
            }
        };


    if (currencyEnum && !currencySymbol) {
        throw new Error('Could not find a currency symbol for your ENUM');
    }

    if (!amount && !currencySymbol) {
        return '';
    } else if (currencySymbol && !amount) {
        return accounting.formatMoney(0, formatOptions);
    } else if (currencySymbol && amount) {
        return accounting.formatMoney(amount, formatOptions);
    } else if (!currencySymbol) {
        throw new Error('You cannot pass an amount but not a currency');
    }
};

module.exports = price;


//////////////////
// WEBPACK FOOTER
// ./~/bunsen/libraries/helpers/price.js
// module id = 2638
// module chunks = 64